module.exports = __webpack_public_path__ + "img/1.273c31a5.svg";